<adapt-feature-configuration [team]="team"
                             [configItem]="configItem">
    <adapt-incomplete-work
                           message="This grid outlining the permissions associated with each role will not be visible on production - it is debug only.">
    </adapt-incomplete-work>

    <adapt-user-access-summary-grid [team]="team"></adapt-user-access-summary-grid>
</adapt-feature-configuration>
